export default function processDirective() {
  return {
    template: require('./process.html'),
    scope: {
      customerId: '<',
      department: '=',
      process: '=',
      isEdit: '<',
      isIt: '=',
      tooltipAppendToSelector: '@',
    },
    controller: 'ProcessController',
    controllerAs: 'processVM',
    bindToController: true,
    replace: true,
  };
}
